module.exports = __webpack_public_path__ + "img/6.a930e25c.jpg";